import "simplyCountdown.js/dev/simplyCountdown.js";

const eventsSingle = () => {
  
  const $countdown = $('.event-countdown-wrap .countdown');
  
  if ($countdown.length) {
    
    let currentDate = new Date(); 
    let cDay = currentDate.getDate();
    let cMonth = currentDate.getMonth();
    let cYear = currentDate.getFullYear();
    let cHours = currentDate.getHours();
    let cMins = currentDate.getMinutes();
    let cSecs = currentDate.getSeconds();

    let now = new Date(cYear, cMonth, cDay, cHours, cMins, cSecs);
    
    $countdown.each(function(i ,el) {
      
      const $this = $(this);
      const $text = $this.parent().find('.label');
            
      const $year = $this.attr('data-cd-year');
      const $month = $this.attr('data-cd-month');
      const $day = $this.attr('data-cd-day');
      const $end = $this.attr('data-cd-end');
      const $soon = $this.attr('data-cd-soon');
      const $current = $this.attr('data-cd-current');
      const $past = $this.attr('data-cd-past');

      let startDate = new Date($year, $month - 1, $day, 0, 0, 0);
      let endDate = new Date($end + ' 23:59:59');

      setTimeout(() => {
        
        // Build countdown
        simplyCountdown(el, { 
          year: Number($year),
          month: Number($month),
          day: Number($day),
          words: { //words displayed into the countdown
            days: { singular: 'day', plural: 'days' },
            hours: { singular: 'hr', plural: 'hrs' },
            minutes: { singular: 'min', plural: 'mins' },
            seconds: { singular: 'scd', plural: 'scds' }
          },
          refresh: 60000,
          onEnd: function () {
            $(el).addClass('over');
          },
          sectionClass: 'cd_section',
          amountClass: 'cd_amount',
          wordClass: 'cd_label',
        });
        
        // Set countdown text
        if (now < startDate) {
          console.log('soon');
          $text.html($soon);
        } else if (now > startDate && now < endDate) {
          console.log('current');
          $text.html($current);
        } else {
          console.log('past');
          $text.html($past);
        }
        
        // Show countdown once built
        $this.parent().addClass('active');
        
      }, 600);
      
    });

  }
  
}

export {
  eventsSingle
};
